import { DashboardOpenMode } from "MyDashboards/state/types";
import React, { FunctionComponent } from "react";
import SlideView from "../../components/SlideView/SlideView";
import SlidesMenu from "../../components/SlidesMenu/SlidesMenu";
import useDashboardStyles from "../themes";

interface CreateDashboardProps {}

const CreateDashboard: FunctionComponent<CreateDashboardProps> = () => {
  const classes = useDashboardStyles()();
  return (
    <div className={classes.page}>
      <div className={classes.slidesMenu}>
        <SlidesMenu openMode={DashboardOpenMode.create} />
      </div>
      <div className={classes.slideView}>
        <SlideView openMode={DashboardOpenMode.create} />
      </div>
    </div>
  );
};

export default CreateDashboard;
